import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { computed, nextTick, ref } from 'vue';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'SearchBox',
  props: {
    value: null,
    disabled: { type: Boolean }
  },
  emits: ["input", "active-change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: string): void;
  (e: 'active-change', check: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: string;
  disabled: boolean;
};





const { t } = useI18n();

const enteredText = computed({
  get() {
    return props.value;
  },
  set(newValue) {
    emit('input', newValue);
  },
});

const isSearchBoxShown = ref(false);
const textInputRef = ref<any>();

async function activateSearch() {
  isSearchBoxShown.value = true;

  nextTick(() => {
    textInputRef.value.focus();
  });
  emit('active-change', true);
}

async function closeSearch() {
  isSearchBoxShown.value = false;
  enteredText.value = '';
  emit('active-change', false);
}

return { __sfc: true,props, emit, t, enteredText, isSearchBoxShown, textInputRef, activateSearch, closeSearch }
}

})